/* eslint-disable jsx-a11y/anchor-is-valid */


import { useState } from "react";
import * as EmailJS from 'emailjs-com';

//#region interfaces

export interface ContactPageProps {
  title: string;
  titleClass: string;
}

//#endregion

//#region component definition
export const ContactPage: React.FC<ContactPageProps> = (props: ContactPageProps) => {
  
  const [firstName, setFirstName] = useState<string>('');
  const [secondtName, setSecondtName] = useState<string>('');
  const [topic, setTopic] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const handleEmailSending = () => {
    if ((firstName === '') || (secondtName === '') || (topic === '') || (email === '') || (message === ''))
      return;
    const data = {
      client_name: firstName + secondtName,
      client_email: email,
      message: message,
      topic: topic
    };
    EmailJS.send('service_axq16ke', 'contact_form', data, 'user_Aud2GYZ131HgDN7T9M0Ps')
      .then((response) => {
        console.log(response.status, response.text);
        setFirstName('');
        setSecondtName('');
        setTopic('');
        setEmail('');
        setMessage('');
      })
      .catch((error) => console.log(error));
  }
  
  return (
    <section className="page-wrapper" id="Contact">
      <section className="page contact-page">
        <h1 className={`${props.titleClass ? props.titleClass : ''}`}>{props.title}</h1>
        <section className="contact-page-form">
          <input type="text" id="first-name" placeholder="שם פרטי" value={firstName} onChange={(event) => setFirstName(event.target.value)} />
          <input type="text" id="second-name" placeholder="שם משפחה" value={secondtName} onChange={(event) => setSecondtName(event.target.value)} />
          <input type="text" id="topic" placeholder="נושא" value={topic} onChange={(event) => setTopic(event.target.value)} />
          <input type="text" id="email" placeholder="אימייל" value={email} onChange={(event) => setEmail(event.target.value)} />
          <textarea id="message" placeholder="פרטי הפנייה"  value={message} onChange={(event) => setMessage(event.target.value)} />
          <button type="button" id="send" onClick={handleEmailSending}>שלח/י</button>
        </section>
      </section>
    </section>
  );
}
//#endregion